import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from "react-bootstrap";
import './pageHeader.scss';

/**
 * Date     :   2020-06-18
 * Author   :   Dinushka Rukshan
 * Remarks  :   Page header with breadcrumb
 */
class PageHeader extends Component {
    constructor(props) {
        super(props)

        this.state = {}
    }

    openImageDownloadLink(downloadUrl) {
        if (!(downloadUrl === undefined || downloadUrl === null || downloadUrl === "")) {
            window.open(downloadUrl, '_blank');
        }
    };

    render() {
        const { breadcrumb, headerText, imageUrl, imageOnClickUrl, noCrumb,children } = this.props;
        const downloadLink = (imageOnClickUrl === undefined || imageOnClickUrl === null || imageOnClickUrl === "") ? "" : imageOnClickUrl;
        const pageHeaderImage = (imageUrl === undefined || imageUrl === null || imageUrl === "") ?
            "https://essstr.blob.core.windows.net/uiimg/PageHeader/DefaultPageHeader.png" : imageUrl;
        return (
            // <div id={id} className="page-header-area"
            // <div id={id.toString()} className="page-header-area"
            <div className="page-header-area"
                style={{
                    backgroundImage: `url(${pageHeaderImage})`,
                    cursor: `${this.props.isClickable ? 'pointer' : ''}`
                }}
                onClick={this.openImageDownloadLink.bind(this, downloadLink)}>
                <div id="page-header">
                    <Row style={{ margin: 0 }}>
                        {noCrumb ? null :
                            <Col xs="12" md={{ span: 10, offset: 1 }}>
                                <div className="page-header-breadcrumb">
                                    <a onClick={() => window.location.href = '/'} className="page-header-breadcrumb-link">
                                        Home
                                    </a>
                                    <i className="fas fa-caret-right" />
                                    <div>
                                        <a>{breadcrumb === undefined ? headerText === undefined ? "" : headerText : breadcrumb}</a>
                                    </div>
                                </div>
                            </Col>}

                    </Row>
                    <Row style={{ margin: 0 }}>
                        <Col xs="12" md={{ span: 10, offset: 1 }}>
                            <span>{headerText === undefined ? "" : headerText}</span>
                        </Col>
                    </Row>
                    {children && <Row style={{ margin: 30 }}>
                                    <Col xs="12" md={{ span: 10, offset: 1 }}>
                                        {children}
                                    </Col>
                                </Row>
                    }
                </div>
            </div>
        )
    }
}

export default PageHeader;
